import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

function revealFunction() {
	if($(".wp-block-thefuturblocks-int-links__wrapper.anim-reveal").length) {
	gsap.registerPlugin(ScrollTrigger);

		ScrollTrigger.batch(".wp-block-thefuturblocks-int-link", {
		  onEnter: batch => {
		    batch.forEach((section, i) => {
		      gsap.fromTo(section, {autoAlpha:0,y:20}, {
		      	autoAlpha: 1,
		      	y: 0,
		        duration: 0.6,
		        stagger: 0.1,
		        delay: i * 0.2,
		      });
		    });
		  },
  		  once: true,
		  start: "+=60 bottom"
		});
	}
}

function hoverFunction() {
	if($(!".wp-block-thefuturblocks-int-links").length && window.matchMedia("(max-width: 1024px)")) {
		return;
	}
	$('.wp-block-thefuturblocks-int-link').each(function(i,el) {
		var self = $(this),
			link = self.find(".wp-block-thefuturblocks-int-link__holder"),
			img = self.find(".wp-block-thefuturblocks-int-link__image"),
			secImg = self.find(".wp-block-thefuturblocks-int-link__sec-image");
		let tl = gsap.timeline({paused:true});

		tl.fromTo(img, {y:30,autoAlpha:0},{y:0, autoAlpha:1, duration:0.7, ease:"power2.inOut"})
		.fromTo(secImg, {y:-30,autoAlpha:0},{y:0, autoAlpha:1, duration:0.7, ease:"power2.inOut"}, "<");

		link.on("mouseenter", function() {
			$(this).addClass('active');
			gsap.to('.wp-block-thefuturblocks-int-link__holder:not(.active)', {autoAlpha:0.2,duration:0.5, ease:"none",overwrite:"true"})
			// gsap.fromTo(img, {y:60,autoAlpha:0},{y:0, autoAlpha:1, duration:0.5})
			tl.play()
		}).on("mouseleave", function() {
			$(this).removeClass('active');
			gsap.to('.wp-block-thefuturblocks-int-link__holder:not(.active)', {autoAlpha:1,duration:0.5, ease:"none"})
			// gsap.to(img, {y:60,autoAlpha:0, duration:0.5})
			tl.reverse()
		})
	})
}

$(window).on('load', () => {
  hoverFunction();
  if($('.c-loader').length) {
    gsap.delayedCall(4, function() {
      revealFunction();
    })
  } else {
    gsap.delayedCall(0.4, function() {
      revealFunction();
    })
  }
})